import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ModalDialogService } from 'ngx-modal-dialog';
import { CancelModalComponent } from '../modal-cancel-component/modal-cancel-component';
import { authenticaitonModel } from '../authentication/model/authenticaiton.model';
import { headersBase } from '../../../helper/headerBase';

@Component({
  selector: 'app-debit-card-payment-component',
  templateUrl: './debit-card-payment.component.html',
  styles: ['li.tabs__tab.active { background-color: #52ae32 !important; color: white; }']
})

export class DebitCardPaymentComponent implements OnInit {
  public debitCardPayments: DebitCardPaymentController[];
  public logs: LogPaymentController[];
  public debitCardPayment: object;
  public log: object;
  public pageSize: number = 5;
  public p: number = 1;
  public total: number = 40;
  public txtSearch: string = "*";
  public modalService: ModalDialogService;
  public viewRef: ViewContainerRef;
  public loading: boolean;
  currentUser: authenticaitonModel = null;

  constructor(modalService: ModalDialogService, viewRef: ViewContainerRef, private _http: HttpClient) {
    this.modalService = modalService;
    this.viewRef = viewRef;
  }

  public openNewDialog() {
    this.modalService.openDialog(this.viewRef, {
      title: 'Confirmação de cancelamento',
      settings: { headerClass: "modal-header HeaderModalCancel", },
      childComponent: CancelModalComponent,

      actionButtons: [
        { text: 'Fechar' }, //  nenhum processamento especial aqui
        { text: 'Cancelar pagamento', onAction: () => this.cancelPayment(), buttonClass: "btn btn-outline btnCancelPayment" },
        // { text: 'Eu nunca fecho', onAction: () => false },
      ]
    });
  }

  public doSearch($event: Event) {
    this.txtSearch = ($event.target as HTMLInputElement).value;
    this.getDebitCardPayments(this.p);
  }

  public doSearchClear() {
    this.txtSearch = "*";
    this.getDebitCardPayments(this.p);
  }

  public refrehPage() {
    this.getDebitCardPayments(this.p);
  }

  public getDebitCardPayments(page) {
    this.loading = true;

    return this._http.get<DebitCardPaymentController[]>("/" + "DebitCard/getpayments/" + page + "/" + this.txtSearch, headersBase()).subscribe(result => {
      this.loading = false;
      this.debitCardPayments = result["listDebitCard"];
      this.debitCardPayment = result["listDebitCard"][0];
      this.pageSize = result["pageSize"];
      this.p = result["currentPage"];
      this.total = result["totalRecords"];
    });
  }

  public displayLog(id) {
    if (document.getElementById(id).style.display == "block") {
      document.getElementById(id).style.display = "none";
    }

    else {
      document.getElementById(id).style.display = "block";
    }
  }

  public getLogs(paymentId) {
    this.logs = [];
    return this._http.get<LogPaymentController[]>("/" + "Log/" + paymentId + "/getlogsbypaymentId", headersBase()).subscribe(result => {

      if (result && result.length > 0) {
        this.logs = result;
        this.log = result[0];
      }

    });
  }

  public setDebitCardPayment(index) {
    this.debitCardPayment = this.debitCardPayments[index];
    this.debitCardPayment["classStatus"] = "hidden";
    if (this.debitCardPayment["payment"]["captured"]) {
      this.debitCardPayment["classStatus"] = "cardCapturedTransaction";
      this.debitCardPayment["textStatus"] = "Este pagamento está capturado";
      this.debitCardPayment["classButtonCapture"] = "hidden";
    }
    if (this.debitCardPayment["payment"]["canceled"]) {
      this.debitCardPayment["classStatus"] = "cardCanceledTransaction";
      this.debitCardPayment["textStatus"] = "Este pagamento está cancelado";
      this.debitCardPayment["classButtonCancel"] = "hidden";
      this.debitCardPayment["classButtonCapture"] = "hidden";
    }
  }

  public openModal(modal, index) {
    document.getElementById(modal).style.display = "block";
    document.getElementById(modal).style.backgroundColor = "rgba(12, 0, 0, 0.5)";

    this.setDebitCardPayment(index);
    this.getLogs(this.debitCardPayment["id"]);
  }

  public closeModal(modal) {
    document.getElementById(modal).style.display = "none";
    //this.loading = false;
  }

  public cancelPayment() {
    this._http.delete<DebitCardPaymentController[]>("/" + "DebitCard/" + this.debitCardPayment["id"] + "/cancelpaymentdebitcard", headersBase()).subscribe(result => {
      if (result["status"] == "voided") {
        /////this.toastr.success('Pagamento cancelado com sucesso!', 'Mensagem');
      }
      else {
        ///////this.toastr.error('Não foi possível cancelar os pagamentos!', 'Atenção');
      }
      this.getDebitCardPayments(this.p);
      this.closeModal('modalDetailPaymentDebitCard');
      //window.location.reload();
    });
    return true;

  }

  public capturePayment() {
    return this._http.get<DebitCardPaymentController[]>("/" + "DebitCard/" + this.debitCardPayment["id"] + "/capturepaymentdebitcard", headersBase()).subscribe(result => {
      if (result["status"] == "payment-confirmed") {
        //this.toastr.info('Pagamento capturado com sucesso!', 'Mensagem');
      }
      else {
        //this.toastr.error('Não foi possível capturado os pagamentos!', 'Atenção');
      }
      window.location.reload();

    });
  }

  public pageChanged(event) {
    this.getDebitCardPayments(event);
  }

  ngOnInit() {
    if (!this.loggedUser()) {
      window.location.href = "/authentication";
    }

    this.getDebitCardPayments(1);
  }

  loggedUser() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser && this.currentUser.userPermission) {
      return true;
    }
  }
}

interface DebitCardPaymentController { }

interface LogPaymentController { }
